export function slugify(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export function blogSlug(blog) {
  return `${slugify(blog.title)}-${blog.id}`;
}

export function idFromSlug(slug) {
  const match = slug.match(/-(\d+)$/);
  return match ? match[1] : slug;
}
